import {useDispatch,useSelector} from 'react-redux';
import { NavLink } from "react-router"
const Sidebar  = () =>{
   const language = useSelector((state) => {
        return state.settingreducer.language;
   });
   return(
     <>
            <div class="sidebar" data-background-color="dark">
                    <div class="sidebar-logo">

                        <div class="logo-header" data-background-color="dark">
                            <a href="index.html" class="logo">
                                <img
                                    src="assets/img/kaiadmin/logo_light.svg"
                                    alt="navbar brand"
                                    class="navbar-brand"
                                    height="20"
                                />
                            </a>
                            <div class="nav-toggle">
                                <button class="btn btn-toggle toggle-sidebar">
                                    <i class="gg-menu-right"></i>
                                </button>
                                <button class="btn btn-toggle sidenav-toggler">
                                    <i class="gg-menu-left"></i>
                                </button>
                            </div>
                            <button class="topbar-toggler more">
                                <i class="gg-more-vertical-alt"></i>
                            </button>
                        </div>

                    </div>
                    <div class="sidebar-wrapper scrollbar scrollbar-inner">
                        <div class="sidebar-content">
                            <ul class="nav nav-secondary">
                                <li class="nav-item active">
                                    <NavLink to='/dashboard'><i class="fas fa-home"></i> {language.dashboard} </NavLink>
                                </li>
                                
                                <li class="nav-item">
                                    <NavLink to='/department'><i class="fas fa-building"></i> {language.department}</NavLink>
                                </li>

                                <li class="nav-item">
                                    <NavLink to='/designation'><i class="fas fa-angle-right"></i> {language.designations}</NavLink>
                                </li>

                                <li class="nav-item">
                                    <NavLink to='/employees'><i class="fas fa-users"></i> {language.employees}</NavLink>
                                </li>

                                <li class="nav-item">
                                    <NavLink to='/leaves'><i class="fas fa-angle-right"></i> {language.leaves}</NavLink>
                                </li>

                                <li class="nav-item">
                                    <NavLink to='/Users'><i class="fas fa-user"></i> {language.reports}</NavLink>
                                </li>

                               

                                <li class="nav-item">
                                    <NavLink to='/accesscontrol'><i class="fa fa-universal-access"></i> {language.accesscontrol}</NavLink>
                                </li>

                                <li class="nav-item">
                                    <NavLink to='/settings'><i class="fa fa-cog"></i> {language.settings}</NavLink>
                                </li>
                                
                               
                                {/* <li class="nav-item">
                                    <a data-bs-toggle="collapse" href="#sidebarLayouts">
                                        <i class="fas fa-th-list"></i>
                                        <p>Sidebar Layouts</p>
                                        <span class="caret"></span>
                                    </a>
                                    <div class="collapse" id="sidebarLayouts">
                                        <ul class="nav nav-collapse">
                                            <li>
                                                <a href="sidebar-style-2.html">
                                                    <span class="sub-item">Sidebar Style 2</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="icon-menu.html">
                                                    <span class="sub-item">Icon Menu</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li class="nav-item">
                                    <a data-bs-toggle="collapse" href="#forms">
                                        <i class="fas fa-pen-square"></i>
                                        <p>Forms</p>
                                        <span class="caret"></span>
                                    </a>
                                    <div class="collapse" id="forms">
                                        <ul class="nav nav-collapse">
                                            <li>
                                                <a href="forms/forms.html">
                                                    <span class="sub-item">Basic Form</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li class="nav-item">
                                    <a data-bs-toggle="collapse" href="#tables">
                                        <i class="fas fa-table"></i>
                                        <p>Tables</p>
                                        <span class="caret"></span>
                                    </a>
                                    <div class="collapse" id="tables">
                                        <ul class="nav nav-collapse">
                                            <li>
                                                <a href="tables/tables.html">
                                                    <span class="sub-item">Basic Table</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="tables/datatables.html">
                                                    <span class="sub-item">Datatables</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li class="nav-item">
                                    <a data-bs-toggle="collapse" href="#maps">
                                        <i class="fas fa-map-marker-alt"></i>
                                        <p>Maps</p>
                                        <span class="caret"></span>
                                    </a>
                                    <div class="collapse" id="maps">
                                        <ul class="nav nav-collapse">
                                            <li>
                                                <a href="maps/googlemaps.html">
                                                    <span class="sub-item">Google Maps</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="maps/jsvectormap.html">
                                                    <span class="sub-item">Jsvectormap</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li class="nav-item">
                                    <a data-bs-toggle="collapse" href="#charts">
                                        <i class="far fa-chart-bar"></i>
                                        <p>Charts</p>
                                        <span class="caret"></span>
                                    </a>
                                    <div class="collapse" id="charts">
                                        <ul class="nav nav-collapse">
                                            <li>
                                                <a href="charts/charts.html">
                                                    <span class="sub-item">Chart Js</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="charts/sparkline.html">
                                                    <span class="sub-item">Sparkline</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li class="nav-item">
                                    <a href="widgets.html">
                                        <i class="fas fa-desktop"></i>
                                        <p>Widgets</p>
                                        <span class="badge badge-success">4</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a href="../../documentation/index.html">
                                        <i class="fas fa-file"></i>
                                        <p>Documentation</p>
                                        <span class="badge badge-secondary">1</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a data-bs-toggle="collapse" href="#submenu">
                                        <i class="fas fa-bars"></i>
                                        <p>Menu Levels</p>
                                        <span class="caret"></span>
                                    </a>
                                    <div class="collapse" id="submenu">
                                        <ul class="nav nav-collapse">
                                            <li>
                                                <a data-bs-toggle="collapse" href="#subnav1">
                                                    <span class="sub-item">Level 1</span>
                                                    <span class="caret"></span>
                                                </a>
                                                <div class="collapse" id="subnav1">
                                                    <ul class="nav nav-collapse subnav">
                                                        <li>
                                                            <a href="#">
                                                                <span class="sub-item">Level 2</span>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#">
                                                                <span class="sub-item">Level 2</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li>
                                                <a data-bs-toggle="collapse" href="#subnav2">
                                                    <span class="sub-item">Level 1</span>
                                                    <span class="caret"></span>
                                                </a>
                                                <div class="collapse" id="subnav2">
                                                    <ul class="nav nav-collapse subnav">
                                                        <li>
                                                            <a href="#">
                                                                <span class="sub-item">Level 2</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <span class="sub-item">Level 1</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                </div>       
     </>
   );   
}

export default Sidebar;

